import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { mtechnavi } from '~/shared/libs/clientsdk';
import {
  FilterRequest,
  FullMethodName_UncompletedListBusinessUnitRelationRequests,
} from '~/worker';
import { PageState, movePage } from '~/shared/utils';
import { GetMessageWithIntl } from '../parts/Message/Message';
import { SectionStateProps } from '../ui/TaskListView';

import './base.css';

const BUSINESS_UNIT_RELATION_RECEPTION_URL = '/businessunit-relation-reception';

// 未処理の取引申請の取得
const uncompletedListBusinessUnitRelationRequests =
  async (): Promise<mtechnavi.api.company.UncompletedListBusinessUnitRelationRequestsResponse> => {
    const option: FilterRequest = {
      action: 'reload',
      fullMethodName:
        FullMethodName_UncompletedListBusinessUnitRelationRequests,
      filter: {},
      sort: [],
    };
    option.requestBody = {};
    try {
      return (await window.App.services.ui.worker.filter(
        option
      )) as mtechnavi.api.company.UncompletedListBusinessUnitRelationRequestsResponse;
    } catch (err) {
      console.error('Error uncompletedListBusinessUnitRelationRequests', err);
      return (async () =>
        new mtechnavi.api.company.UncompletedListBusinessUnitRelationRequestsResponse())();
    }
  };

export interface TaskBusinessUnitRelationProps extends SectionStateProps {}

export const TaskBusinessUnitRelation = (
  props: TaskBusinessUnitRelationProps
) => {
  const intl = useIntl();
  const navi = useNavigate();
  const { onChangeLoadingState } = props;

  const [relationRequestCount, setRelationRequestCount] = useState(0);

  // 遷移処理
  const handleMovePage = (e: React.MouseEvent, url: string) => {
    e.preventDefault();
    const state: PageState = {
      sourceViewId: 'TASK_LIST',
    };
    movePage(state, navi, url);
  };

  // 取引申請受付
  const callUncompletedListRelationRequests = async () => {
    const { items } = await uncompletedListBusinessUnitRelationRequests();
    setRelationRequestCount(items.length);
  };

  useEffect(() => {
    onChangeLoadingState && onChangeLoadingState(true);
    Promise.all([
      callUncompletedListRelationRequests(), // 取引申請受付
    ]).finally(() => {
      onChangeLoadingState && onChangeLoadingState(false);
    });
    // 正確にローディング状況を伝えることが困難なため、依存関係に含めない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {relationRequestCount > 0 && (
        <div className="TaskList">
          <dl>
            <dt className="title">
              {GetMessageWithIntl(intl, {
                id: 'TaskList.title.businessUnitRelation',
              })}
            </dt>
            <dd>
              <a
                href="#"
                className="link"
                onClick={(e) => {
                  handleMovePage(e, BUSINESS_UNIT_RELATION_RECEPTION_URL);
                }}
              >
                {GetMessageWithIntl(intl, {
                  id: 'TaskList.taskItem.businessUnitRelationReception',
                })}{' '}
                {`（${relationRequestCount}）`}
              </a>
            </dd>
          </dl>
        </div>
      )}
    </>
  );
};
